export const formatNumericNumber = (value) => {
  return new Intl.NumberFormat().format(value);
};

export const formatCurrencyInEuro = (number) => {
  return new Intl.NumberFormat("de-DE").format(number);
};

export const formatAbbreviationNumber = (value) => {
  if (!value) return;
  return Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 2,
  }).format(value);
};

export const formatCurrency = (amount, currencyCode) => {
  const formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  // Format the number
  let formatted = formatter.format(amount);
  const regex = /^([^\d]+)(.*)$/;
  const match = formatted.match(regex);

  if (match) {
    const [, symbol, value] = match;
    return `${symbol.trim()} ${value.trim()}`;
  }

  return formatted;
};

// Formats a number to a string with specified decimal places (e.g., 20.18).
export const formatToDecimal = (
  value,
  minFractionDigits = 0,
  maxFractionDigits = 2
) => {
  return parseFloat(value).toLocaleString(undefined, {
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits,
  });
};
